
import { defineComponent } from 'vue'

import ActiveUserMixin, { type DashboardContext } from '~/mixins/activeUserMixin'
import { TeamPerms } from '~/types/permTypes'
import { PAUSE_REASON_PAST_DUE } from '~/utils/billing'

const pauseImagePng = require('~/assets/images/ui-states/subscription-paused.png')
const pauseImageWebp = require('~/assets/images/ui-states/subscription-paused.webp')

export default defineComponent({
  name: 'SubscriptionPausedState',

  mixins: [ActiveUserMixin],

  data() {
    return {
      pauseImagePng,
      pauseImageWebp
    }
  },

  computed: {
    isAdmin(): boolean {
      const ctx = this.activeDashboardContext as DashboardContext
      return (
        ctx?.type !== 'user' &&
        this.$gateKeeper.team(TeamPerms.UPDATE_BILLING_DETAILS, this.teamPerms.permission)
      )
    },
    isPastDue(): boolean {
      // The past-due pause UI is driven by the backend `subscription_pause_reason`.
      // Trial-ended pauses (and V1 billing) carry a different reason and fall back
      // to the generic paused state below.
      return (
        (this.activeDashboardContext as DashboardContext)?.subscription_pause_reason ===
        PAUSE_REASON_PAST_DUE
      )
    },
    contactSalesUrl(): string {
      const base = this.$config.salesUrl
      const params = new URLSearchParams()
      if (this.viewer?.firstName) params.set('first_name', this.viewer.firstName)
      if (this.viewer?.lastName) params.set('last_name', this.viewer.lastName)
      if (this.viewer?.email) params.set('email', this.viewer.email)
      const qs = params.toString()
      return qs ? `${base}?${qs}` : base
    }
  },

  methods: {
    navigateToCheckout() {
      const { provider, owner } = this.$route.params
      if (!provider || !owner) return

      this.$router.push(
        this.$generateRoute(['settings', 'billing', 'checkout'], false, true, provider, owner)
      )
    }
  }
})
